<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-group-subject" data-bs-toggle="modal" data-bs-target="#group-subject-modal-form">Klik</button>
        <div class="modal" id="group-subject-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="form-group form-style-1">
                                    <label class="form-label">Nama Rumpun<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control error" placeholder="Masukan nama Rumpun" v-model="form.name" required oninvalid="this.setCustomValidity('Masukan nama Rumpun')" oninput="this.setCustomValidity('')">
                                </div>                                
                            </div>
                            <div class="d-block">
                                <div v-for="(row, indexRow) in form.total_subject" :key="indexRow" class="d-flex align-items-center mb-3">
                                    <div class="card m-0 w-100">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-7">
                                                    <div class="form-group m-0">
                                                        <label class="form-label">Pelajaran Prasyarat<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                                        <div class="d-block">
                                                            <div class="form-select-wrapper form-select-style-1">
                                                                <i class="fa-solid fa-caret-down"></i>
                                                                <select class="form-select form-select-box-1" v-model="form.subject_list[indexRow].id">
                                                                    <option value="">Pilih Mata Pelajaran</option>
                                                                    <option v-for="(item, index) in filteredDataSubject(indexRow)" :key="index" :value="item.id">{{ item.name }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-5">
                                                    <div class="form-group m-0 form-style-1">
                                                        <label class="form-label">Penambahan Nilai<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                                        <input type="number" class="form-control" v-model="form.subject_list[indexRow].score">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-block flex-shrink-0 ms-3" v-if="row > 1">
                                        <button type="button" v-on:click="removeRowSubject(indexRow)" class="btn btn-white-naked btn-icon" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete"><i class="fa-solid fa-trash-can text-danger"></i></button>
                                    </div>
                                </div>
                            </div>

                            <div class="d-block mb-4" v-if="this.form.total_subject < this.dataSubject.length">
                                <button type="button" class="btn btn-white-naked" v-on:click="addRowSubject"><i class="fa-solid fa-add me-3"></i>Tambah Pelajaran Prasyarat</button>
                            </div>

                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-group-subject">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'GroupSubjectForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id            : "",
                name          : "",
                total_subject : 1,
                subject_list  : [],
            },
            submitted           : false,
            waiting             : false,
            dataSubject         : [],
            initialDataSubject  : [],
        }
    },
    validations: {
        form: {
            name: {
                required
            }
        }
    },
    created() {
        this.getSubject();
        this.initializeSubjectList();
    },
    methods: {
        initializeSubjectList: function() {
            const currentLength = this.form.subject_list.length;
            const newLength = this.form.total_subject;

            if (newLength > currentLength) {
                const diff = newLength - currentLength;
                this.form.subject_list = this.form.subject_list.concat(new Array(diff).fill({ id: '', score: '' }));
            } else if (newLength < currentLength) {
                this.form.subject_list = this.form.subject_list.slice(0, newLength);
            }
        },
        loadForm: function(params="") {
            if(params == '') {
                this.label = 'Tambah';
                this.createForm();
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            document.getElementById('btn-modal-group-subject').click();
            
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-group-subject').click();
            this.$parent.$children[0].$children[0].getData();
            this.createForm();
        },
        createForm: function() {
            for (let key in this.form) {
                if(key == 'subject_list') {
                    this.form.subject_list[0].id = "";
                    this.form.subject_list[0].score = "";
                }
                else if(key == 'total_subject') {
                    this.form.total_subject = 1
                }
                else {
                    this.form[key] = '';
                }
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    if(key == 'subject_list') {
                        formData.append('subject_list', JSON.stringify(this.form.subject_list));
                    } else {
                        formData.append(key, this.form[key]);
                    }
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'group-subject/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });

            }
        },
        getDataByID: function(id) {
            if(id != '') {
                let uri         = process.env.VUE_APP_APIHOST+'group-subject/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets = res.data.data;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];

                                if(key == 'subject_list') {
                                    this.form.total_subject = this.form.subject_list.length;
                                }
                            }
                        }
                    }
                });
            }
        },
        getSubject: function() {
            let uri         = process.env.VUE_APP_APIHOST+'subject/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataSubject = res.data.data;

                this.initialDataSubject = [...this.dataSubject];

            });
        },
        addRowSubject: function() {
            this.form.total_subject = this.form.total_subject+1;
            this.initializeSubjectList();
        },
        removeRowSubject: function(index) {
            this.form.total_subject = this.form.total_subject-1;
            this.form.subject_list.splice(index, 1);
        },
        filteredDataSubject(indexRow) {
            let subject_selected = [];
            this.form.subject_list.forEach((element, i) => {
                if (i !== indexRow) {
                    subject_selected.push(element.id);
                }
            });

            let dataSubject = [];

            this.initialDataSubject.forEach(element => {
                if (!subject_selected.includes(element.id)) {
                    dataSubject.push(element);
                }
            });

            return dataSubject;
        },
    },
}
</script>
